const MyDataContext = React.createContext();

export default MyDataContext;
